// extracted by mini-css-extract-plugin
module.exports = {"LoadingWrapper":"Loading_LoadingWrapper___Oou3","Loading":"Loading_Loading__XcLmc","load4":"Loading_load4__yJJmZ"};